import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-three-sixty-view',
  templateUrl: './three-sixty-view.component.html',
  styleUrls: ['./three-sixty-view.component.less']
})
export class ThreeSixtyViewComponent implements OnInit {

  @Input()
  public images: Array<string>;

  private started = false;
  private delta = 0;
  public value = 0;
  private interval: number;

  constructor() { }

  ngOnInit() {
    this.interval = 360 / this.images.length;
  }

  public getIndex(index: number): number {
    let rangeStart = index*this.interval;
    if(rangeStart <= this.value && rangeStart+this.interval > this.value) { //regular
      return 100;
    } else if (this.value === 360 && index === this.images.length-1) { // 360 deg. = last one
      return 100;
    }
    return 10;
  }

  public onSliderChange(value: string): void {
    this.value = parseInt(value);
  }
  
  private swipe(event: any): void {
    if (!this.started || event.target.tagName!=='IMG') return;
    let realDelta = event.deltaX - this.delta;
    if (this.delta < event.deltaX){
      this.value += (360 / 100 * (realDelta*100/event.target.width));
    } else {
      this.value += (360 / 100 * (realDelta*100/event.target.width));
    }
    if(this.value > 360) {
      this.value -= 360;
    } else if (this.value < 0) {
      this.value += 360;
    }
    this.delta = event.deltaX;
  }
  private startSwipe(event: any): void {
    this.started = true;
  }
  private endSwipe(event: any): void {
    if (!this.started) return;
    let deltaX = event.deltaX;
    this.delta = 0;
    this.started = false;
  }
  public preventDefault(event){
    if (event.preventDefault) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/three-sixty-view/three-sixty-view.component.ts